function exportCSVFile(headers, rows, fileName) {
    const csvContent = [headers, ...rows].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName ?? 'table-data.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

module.exports = {
    exportCSVFile,
}